<template>
  <div style="margin-right: 10px">
    <el-select v-model="tagNoOrEic"
               style="width: 130px;"
               class="prepend-select">
      <el-option v-for="item in searchType"
                 :key="item.value"
                 :label="item.label"
                 :value="item.value">
      </el-option>
    </el-select>
    <el-select v-model="tagCode"
               class="append-select"
               filterable
               remote
               clearable=""
               reserve-keyword
               :placeholder="tagNoOrEic === 1 ? '请输入标签序号' : '请输入设备识别码(至少输入4位)'"
               :remote-method="querySearch"
               :loading="loading"
               @change="handleSelect">
      <el-option v-for="(item, index) in options"
                 :key="index"
                 :label="`${item.productName || '未使用'}【${item.tagType }—${item.isSetName}】${userPermission.ENT ? '' : '——' + item.vendorName}`"
                 :value="item.tagCode">
      </el-option>
    </el-select>
    <tag-search-modal ref="tagSearchModal"
                      :userPermission="userPermission" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TagSearchModal from './tag-search-modal.vue'
let t = null

export default {
  name: 'tag-search-form',
  components: { TagSearchModal },
  props: {
    vendorId: [String, Number]
  },
  data () {
    return {
      tagCode: '',
      tagNoOrEic: 1,
      loading: false,
      options: [],
      searchType: [{ value: null, label: '查询全部' }, { value: 1, label: '按标签序号' }, { value: 2, label: '按设备系列号' }]
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    })
  },
  methods: {
    querySearch (queryString) {
      clearTimeout(t)
      t = setTimeout(() => {
        if (queryString.trim()) {
          this.loading = true
          this.$store.dispatch('label/gettagcodes', {
            payload: { tagNo: queryString.trim(), vendorId: this.vendorId, tagNoOrEic: this.tagNoOrEic },
            success: (res) => {
              this.loading = false
              this.options = res.data.records.map(item => {
                item.tagType = ({ 1: '定制标签', 2: '涂层标签', 3: '芯片标签', 4: '普通标签', 5: '一品一码标签' })[item.tagType]
                item.isSetName = item.isSetCode === 0 ? '产品码' : (item.tagSizeType === 1 ? '产品码（套）' : '套码')
                return item
              })
            },
            fail: () => {
              this.loading = false
              this.options = []
            }
          })
        } else {
          this.options = []
        }
      }, 500)
    },
    handleSelect (tagCode) {
      this.$refs.tagSearchModal.fetch(tagCode)
      this.tagCode = ''
      this.options = []
    }
  }
}
</script>
<style lang="stylus" scoped>
/deep/.prepend-select {
  .el-input__inner {
    border-radius: 4px 0 0 4px !important;
  }
}

/deep/.append-select {
  .el-input__inner {
    border-radius: 0 4px 4px 0 !important;
    border-left-width: 0 !important;
  }
}
</style>
